import React from 'react';
const MISSION_IMAGE = 'https://cdn.magicpatterns.com/uploads/6VNDFTEeWuRsoQPUmRUT27/law1.jpg';
export function MissionSection() {
  return <section id="Mission" className="py-16 md:py-24 lg:py-32 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-662">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-663">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-664">
          <div data-id="element-665">
            <div className="mb-12 md:mb-16" data-id="element-666">
              <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-667">
                Our Mission
              </h2>
              <div className="w-16 h-0.5 bg-brand-teal" data-id="element-668" />
            </div>
            <p className="text-xl text-brand-white font-medium mb-6 leading-relaxed" data-id="element-669">
              Medina Tactical Dynamics is committed to providing our clients
              with highest quality of service combined with a strong sense of
              360° situational awareness.
            </p>
            <div className="space-y-4 text-brand-gray-400 mb-8" data-id="element-670">
              <p className="text-base" data-id="element-671">
                Providing quality services to our clients is our top priority.
                We are available to assist you with your training and consulting
                needs, delivering current and long-term solutions through
                innovative ideas, strategies, and preparedness.
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6" data-id="element-672">
                {['Educational Programs', 'Course Development', 'Use of Force Litigation', 'Law Enforcement Consulting', 'Corporate & Civilian Entities', 'Private Investigation'].map(item => <li key={item} className="flex items-center gap-2 text-sm" data-id="element-673">
                    <div className="w-1.5 h-1.5 bg-brand-teal flex-shrink-0" data-id="element-674" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="p-6 border border-brand-gray-700 bg-brand-black clip-edges" data-id="element-675">
              <h3 className="text-lg font-semibold text-brand-white uppercase mb-2" data-id="element-676">
                The Medina Standard
              </h3>
              <p className="text-sm text-brand-gray-400 mb-6" data-id="element-677">
                We operate with a 24/7 mentality in customer support, ensuring
                you are always prepared for the unexpected.
              </p>
              <a href="/contact" className="inline-flex items-center justify-center font-semibold uppercase tracking-wider transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-teal focus-visible:ring-offset-2 focus-visible:ring-offset-brand-black active:scale-[0.97] active:transition-none clip-edges bg-transparent text-brand-teal border border-brand-teal hover:bg-brand-teal hover:text-brand-white px-4 py-2 text-xs gap-1.5" data-id="element-678">
                Contact Us
              </a>
            </div>
          </div>
          <div className="relative h-full min-h-[400px] border border-brand-gray-700 bg-brand-black p-2" data-id="element-679">
            <img src={MISSION_IMAGE} alt="Strategic Planning for Crisis Situations" className="block absolute inset-2 w-[calc(100%-1rem)] h-[calc(100%-1rem)] object-cover" data-id="element-680" />
            <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand-teal z-10" data-id="element-681" />
            <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand-teal z-10" data-id="element-682" />
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand-teal z-10" data-id="element-683" />
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand-teal z-10" data-id="element-684" />
          </div>
        </div>
      </div>
    </section>;
}